import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Table from "components/Admin/Users/CompanyAdmin/CompanyAdmin";
import Card from "components/Shared/Card/Card.js";
import CardHeader from "components/Shared/Card/CardHeader/CardHeader.js";
import CardBody from "components/Shared/Card/CardBody/CardBody.js";
import { useDispatch, useSelector } from "react-redux";
import {
  getCompanyAdmin,
  createNewCompanyAdmin,
  deleteCompanyAdmin,
  getAllCompanies,
  updateCompanyAdmin,
  changeStatusCompanyAdmin,
} from "store/actions/usersCompanyAdmin";

const CompanyAdmin = () => {
  const companyAdminData = useSelector(
    (state) => state.usersCompanyAdmin.companyAdmin
  );
  const allCompaniesData = useSelector(
    (state) => state.usersCompanyAdmin.allCompanies
  );
  const dispatch = useDispatch();
  const [page, setPage] = useState(
    companyAdminData ? companyAdminData.pag.page : 1
  );
  const [amount, setAmount] = useState(
    companyAdminData ? companyAdminData.pag.amount : 10
  );
  const [orderField, setOrderField] = useState(
    companyAdminData ? companyAdminData.pag.order_field : "created_at"
  );
  const [orderType, setOrderType] = useState(
    companyAdminData ? companyAdminData.pag.order_type : "desc"
  );
  const [searchValue, setSearchValue] = useState("");

  const [searchBy, setSearchBy] = useState(
    companyAdminData ? companyAdminData.pag.search_by : "display_name"
  );

  const history = useHistory();

  useEffect(() => {
    dispatch(
      getCompanyAdmin(
        {
          page,
          amount,
          order_field: orderField,
          order_type: orderType,
          search_value: searchValue,
          search_by: searchBy,
        },
        history
      )
    );
  }, [page, amount, orderField, orderType, searchValue, history, dispatch]);

  useEffect(() => {
    dispatch(getAllCompanies(history));
  }, [dispatch]);

  const deleteHandler = (id) => {
    const pag = {
      page,
      amount,
      order_field: orderField,
      order_type: orderType,
      search_value: searchValue,
      search_by: searchBy,
    };
    dispatch(deleteCompanyAdmin(id, pag, history));
  };
  const createHandler = (newUser) => {
    const pag = {
      page,
      amount,
      order_field: orderField,
      order_type: orderType,
      search_value: searchValue,
      search_by: searchBy,
    };
    dispatch(createNewCompanyAdmin(newUser, pag, history));
  };

  const changeStatusHandler = (ids) => {
    const pag = {
      page,
      amount,
      order_field: orderField,
      order_type: orderType,
      search_value: searchValue,
      search_by: searchBy,
    };
    dispatch(changeStatusCompanyAdmin(ids, pag, history));
  };

  const updateHandler = (newUser) => {
    const pag = {
      page,
      amount,
      order_field: orderField,
      order_type: orderType,
      search_value: searchValue,
      search_by: searchBy,
    };
    dispatch(updateCompanyAdmin(newUser, pag, history));
  };

  return (
    <div>
      <Card>
        <CardHeader color="primary">
          <h4>Company Admin Users Table</h4>
        </CardHeader>
        <CardBody>
          {companyAdminData && (
            <Table
              rows={companyAdminData.data}
              totalRows={companyAdminData.pag.total}
              rowsPerPage={amount}
              setRowsPerPage={setAmount}
              order={orderType}
              setOrder={setOrderType}
              orderBy={orderField}
              setOrderBy={setOrderField}
              page={page - 1}
              setPage={setPage}
              searchHandler={setSearchValue}
              searchValue={searchValue}
              selectedSearchBy={searchBy}
              handleSearchByChange={setSearchBy}
              companies={allCompaniesData}
              deleteUser={deleteHandler}
              createUser={createHandler}
              updateUser={updateHandler}
              changeStatus={changeStatusHandler}
            />
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default CompanyAdmin;
